export const tableEnUSTranslations = {
  editMode: "Edit mode:",
  emptyTableMessage: "Nothing to see here… yet! 💤",
  columns: "Columns",
  toggleColumnVisibility: "Toggle Column Visibility",
  tableActions: "Table actions",
  filterTable: "Filter table",
  filterClear: "Clear",
  textOperatorIs: "is",
  textOperatorIsNot: "is not",
  textOperatorIsAnyOf: "is any of",
  textOperatorIsNotAnyOf: "is not any of",
  dateOperatorEq: "Is exactly",
  dateOperatorGt: "Is after",
  dateOperatorGte: "Is on or after",
  dateOperatorLt: "Is before",
  dateOperatorLte: "Is on or before",
  numericOperatorEq: "Is equal to",
  numericOperatorGt: "Is greater than",
  numericOperatorGte: "Is greater than or equal to",
  numericOperatorLt: "Is less than",
  numericOperatorLte: "Is less than or equal to",
  booleanYes: "Yes",
  booleanNo: "No",
  compoundFilter: "Compound filter",
  compoundFilterAnd: "Compound filter (AND)",
  compoundFilterOr: "Compound filter (OR)",
  removeFilterNamed: "Remove {{label}} filter",
  removeFilter: "Remove filter",
  removeCompoundFilter: "Remove compound filter",
  removeCondition: "Remove condition",
  toggleCellValue: "Toggle value",
  paginationItem: "item",
  paginationItems: "items",
  tableDefaultName: "Data table",
  tableLoading: "Loading...",
  tableRefresh: "Refresh",
  tableNewRecord: "New record",
  selectAllRows: "Select all rows",
  selectRow: "Select {{row}}",
  rowLabelFallback: "row {{number}}",
  rowActionName: "{{action}}: {{row}}",
  rowMenuName: "Actions for {{row}}",
  rowsSelectedVisible: "{{count}} selected row(s)",
  rowsSelectedOne: "1 row selected",
  rowsSelectedMany: "{{count}} rows selected",
  rowSelectedOne: "{{row}} selected. 1 row selected.",
  rowSelectedMany: "{{row}} selected. {{count}} rows selected.",
  rowDeselectedOne: "{{row}} deselected. 1 row selected.",
  rowDeselectedMany: "{{row}} deselected. {{count}} rows selected.",
  rowDeselectedNone: "{{row}} deselected. No rows selected.",
  sortByColumn: "Sort by {{column}}",
  sortStateAscending: "Sorted ascending",
  sortStateDescending: "Sorted descending",
  sortStateNone: "Not sorted",
  sortedAscending: "Sorted by {{column}}, ascending",
  sortedDescending: "Sorted by {{column}}, descending",
  sortCleared: "Sort cleared",
  pagination: "Pagination",
  paginationPrev: "prev",
  paginationNext: "next",
  paginationPreviousName: "Previous page, page {{page}}",
  paginationNextName: "Next page, page {{page}}",
  paginationPreviousEdgeName: "Previous page",
  paginationNextEdgeName: "Next page",
  paginationSummary: "{{count}} {{items}} | Page {{current}} of {{total}}",
  paginationRange:
    "Page {{current}} of {{total}}, showing {{from}} to {{to}} of {{count}}",
  emptyTableAnnouncement: "No rows to show",
  columnShown: "{{column}} column shown",
  columnHidden: "{{column}} column hidden",
  cellEditLabel: "Edit {{column}} for {{row}}",
  cellEditStartImmediate: "Editing {{column}}. Changes save immediately.",
  cellEditStart: "Editing {{column}}. Enter to commit, Escape to cancel.",
  cellEditCommitted: "{{column}} set to {{value}}",
  cellEditUnchanged: "{{column}} unchanged",
  cellEditCancelled: "Edit cancelled. {{column}} restored.",
  selectAnOption: "Select an option...",
  selectionCleared: "Selection cleared",
  reorderMoveColumnLeft:
    "Move left: {{name}} column, position {{position}} of {{total}}",
  reorderMoveColumnRight:
    "Move right: {{name}} column, position {{position}} of {{total}}",
  reorderMoveLeftTip: "Move left",
  reorderMoveRightTip: "Move right",
  columnNarrowerTip: "Narrower",
  columnWiderTip: "Wider",
  columnNarrower: "Narrower: {{name}} column, {{width}} pixels wide",
  columnWider: "Wider: {{name}} column, {{width}} pixels wide",
  columnWidthChanged: "{{name}} column is now {{width}} pixels wide.",
  columnResizeName: "Resize {{name}} column",
  columnResizeValue: "{{width}} pixels wide",
  columnResizeInstructions:
    "Use the Left and Right arrow keys to change the width. Press Home for the narrowest, End for the widest.",
};
